import React from "react";

const Donation = () => {
  return <div>Donation</div>;
};

export default Donation;
